<script>

  export default {
    props: ["value"],
    computed: {
      _value: {
        get: function() {
          return this.value;
        },
        set: function(newValue) {
          this.$emit('input', newValue);
        }
      }
    },
    watch: {
      '_value': function(newValue, oldValue) {
        if (newValue) {

          let label = newValue.pt;

          if (this.$i18n.locale == 'es' && newValue.es) {
            label = newValue.es;
          } else if (this.$i18n.locale == 'en' && newValue.en) {
            label = newValue.en;
          }

          if(label) {
            this.$alert(
              label,
              this.$t('error') + "!",
              {
                confirmButtonText: 'OK',
                type: 'error'
              }
            );
          }
        }
      }
    }
  }

</script>

<template>
</template>



// WEBPACK FOOTER //
// SgsRenderNotificationError.vue?3917a3db